import { USERBACK_TOKEN } from '../config.js'
import type { UserbackOptions, UserbackWidget } from '@userback/widget'
import './userback.css'

let userbackInstance: UserbackWidget

export async function initUserback(
  options?: UserbackOptions
): Promise<UserbackWidget | undefined> {
  if (!USERBACK_TOKEN) return

  // Don't re-initialize if already initialized
  if (userbackInstance) {
    return userbackInstance
  }

  // Conditionally import the Userback widget so that it does not get loaded
  // on instances where it is not meant to be installed.
  const mod = await import('@userback/widget')

  // TODO: capture user info from subscribers.
  userbackInstance = await mod.default(USERBACK_TOKEN, options)

  return userbackInstance
}

export function getUserback() {
  if (userbackInstance) {
    return userbackInstance
  }
}
